// extracted by mini-css-extract-plugin
export var blue = "_3n-g";
export var brand = "_3n-c";
export var darkGrey = "_3n-f";
export var disabled = "_3n-6";
export var disabledSubtle = "_3n-7";
export var error = "_3n-8";
export var green = "_3n-h";
export var grey = "_3n-e";
export var icon = "_3n-0";
export var inherit = "_3n-b";
export var lightGrey = "_3n-d";
export var orange = "_3n-j";
export var pink = "_3n-l";
export var primary = "_3n-1";
export var purple = "_3n-m";
export var quaternary = "_3n-4";
export var quinary = "_3n-5";
export var red = "_3n-k";
export var secondary = "_3n-2";
export var success = "_3n-a";
export var tertiary = "_3n-3";
export var warning = "_3n-9";
export var white = "_3n-n";
export var yellow = "_3n-i";